<template>
    <div>
        <ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
    </div>
</template>
<script>
import ReFormPrinter from './FormPrinter/ReFormPrinter.vue';

export default {
    name: 'ReConfig',
    components:{
        ReFormPrinter,
    },
    data(){
        return {
            masAllFormParams: [],
            currentApiFormMethod:{}
        }
    },
    props:{
        obj:String,
        close: Function,
    },
    methods:{
        LoadForm(){
            this.$GVO
                .ApiCall('Config_form',{obj:this.obj, flt:{}})
                .then(objData=>{
                    // console.log(objData);
                    this.masAllFormParams = objData.form;
                    this.currentApiFormMethod = objData.save;
                })
        },
        SuccessGo(path, params){
            // console.log(params);
            this.$emit('close');
        }
    }, 
    created(){
        // Запросить настройки
        this.LoadForm();
    }
}
</script>
<style lang="scss" scoped>
</style>